export const ACCOUNT_TYPES = ["checking", "savings"];
